<!--
  ~ Copyright (c) 2019. ProVision Media Group Ltd. <https://provision.bg>
  ~ Venelin Iliev <http://veneliniliev.com>
  -->

<small
  *ngIf="formControlItem.invalid && (formControlItem.dirty || formControlItem.touched)"
  class="form-text theme-color-danger"
>
  <span *ngIf="formControlItem.errors.required">This field is required</span>
  <span *ngIf="formControlItem.errors.minlength">This field is too short</span>
  <span *ngIf="formControlItem.errors.maxlength">This field is too long</span>
  <span *ngIf="formControlItem.errors.pattern">Invalid value for this field</span>
</small>
